import { Layout } from "antd";
import styled from "styled-components";
const { Content } = Layout;

export const ContentContainer = styled(Content) <{ isServiceContractMode: boolean }>`
    margin: ${props => props.isServiceContractMode ? "0" : "8px 16px 0"};
    overflow: initial;
    min-height: 80vh !important;
`